/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { memo, useState } from 'react'

import { useMatchMedia } from '../../hooks/useMatchMedia'

import Img from '../Img'
import Label from '../Label'

const Aside = ({
  data,
  logo,
  description,
  resultsLabel,
  results,
  mobileFilters,
}) => {
  const { isMatching, calculated } = useMatchMedia('(max-width:610px)', true)
  return (
    <aside className="story-aside">
      {isMatching && calculated && (
        <div>
          <Img image={logo.gatsbyImageData} alt={logo.alt} className="logo" />
          {mobileFilters.map((item) => (
            <MobileAsideList key={item}>
              <MobileListItems data={item} />
            </MobileAsideList>
          ))}
          <MobileAsideList>
            <>
              <div className="mobile-filters-label">{resultsLabel?.text}</div>
              <div className="mobile-filters-content">
                <ResultsItems data={results} />
              </div>
            </>
          </MobileAsideList>
        </div>
      )}
      {!isMatching && calculated && (
        <>
          <div className="story-block">
            <Img image={logo.gatsbyImageData} alt={logo.alt} className="logo" />
            <p className="p-16 p">{description}</p>
          </div>
          {data?.map((item) => (
            <div key={item} className="story-block">
              <Label className="story-label" text={item.filters_label.text} />
              <p className="p p-16">{item.filters_description.text}</p>
            </div>
          ))}
          <div className="story-block">
            <Label className="story-label" text={resultsLabel.text} />
            <ResultsItems data={results} />
          </div>
        </>
      )}
    </aside>
  )
}

const ResultsItems = ({ data }) =>
  data?.map((item) => (
    <div className="results-item" key={item}>
      <p className="results-item-title fw-700">{item?.big_label?.text}</p>
      <p className="p-16 p">{item?.text?.text}</p>
    </div>
  ))

const MobileListItems = ({ data }) => (
  <>
    <div className="mobile-filters-label">{data?.filters_label?.text}</div>
    <div className="mobile-filters-content">
      {data?.filters_description?.text}
    </div>
  </>
)

const MobileAsideList = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false)

  const handleToggle = () => setIsOpen(!isOpen)
  return (
    <div
      onClick={handleToggle}
      className={`mobile-filters ${isOpen ? 'active' : ''}`}
    >
      {children}
    </div>
  )
}

export default memo(Aside)
